import React from 'react'
import logoReto from '../../images/elretodecarmen.png'
import logoPequeñoDeseo from '../../images/deseo.jpeg'

function Footer() {
  return (
          <footer className="colabora-footer-logos">
          <div className="logos-row">
            <img src={logoReto} alt="El Reto de Carmen" className="footer-mini-logo" />
            <div className="vertical-divider"></div>
            <img src={logoPequeñoDeseo} alt="Pequeño Deseo" className="footer-mini-logo" />
          </div>
          <p className="footer-motto">"A veces, el cumplimiento de un deseo es la mejor medicina"</p>
        </footer>
  )
}

export default Footer